import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { listSectorsQueryKey } from "@modules/bookSectors/services/queries";
import { useCreateSectorMutation } from "@modules/bookSectors/services/mutations";
import { SectorFormValues, sectorSchema } from "@modules/bookSectors/validations";

export function useCreateSectorModal(modalRef: RefObject<ModalRef>, onComplete: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<SectorFormValues>({
    resolver: zodResolver(sectorSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateSectorMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listSectorsQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("book_sector_admin.success.create"),
      });

      onComplete();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
